export const USER_TOKEN = 'USER_TOKEN'
export const IS_LOGIN = 'IS_LOGIN'
export const USER_INFO = 'USER_INFO'
export const USER_LOCATIONS = 'USER_LOCATIONS'
export const USER_SELECTED_LOCATION = 'USER_SELECTED_LOCATION'

export const BASE_64_PDF = 'BASE_64_PDF'
